import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './CenterItem.module.scss';

const cx = classNames.bind(styles);

function CenterItem({ link = '', name = '', simpleAddress = '', tel = '', centerPhone = '' }) {
	return (
		<li>
			<Link
				to={`/encar-center/location/${link}`}
				className={cx('link_center')}
			>
				<strong className={cx('tit_name')}>{name}</strong>
				<p className={cx('txt_address')}>{simpleAddress}</p>
				<span className={cx('txt_tel')}>{tel}</span>
				{centerPhone && <span className={cx('txt_tel')}> / {centerPhone}</span>}
			</Link>
		</li>
	);
}

export default CenterItem;
